import { render, staticRenderFns } from "./online-banner.vue?vue&type=template&id=21fc642b&functional=true"
import script from "./online-banner.vue?vue&type=script&lang=js"
export * from "./online-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports